import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => {
    const isDark = theme.palette.mode === 'dark'
    return {
        chatPanel: {
            position: 'fixed',
            width: 360,
            maxWidth: 'calc(100vw - 32px)',
            maxHeight: 480,
            borderRadius: 8,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            zIndex: 10000,
            boxShadow: isDark
                ? '0 8px 32px rgba(0, 0, 0, 0.5)'
                : '0 8px 32px rgba(0, 0, 0, 0.12)',
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            transition: 'opacity 0.2s ease-out, transform 0.2s ease-out'
        },
        chatHeader: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '12px 16px',
            borderBottom: `1px solid ${theme.palette.divider}`,
            backgroundColor: isDark ? theme.palette.grey[900] : theme.palette.grey[50]
        },
        chatTitle: {
            fontWeight: 600,
            fontSize: 14
        },
        chatContent: {
            flex: 1,
            overflow: 'auto',
            padding: 16,
            minHeight: 200
        },
        chatPlaceholder: {
            color: theme.palette.text.secondary,
            fontSize: 13,
            lineHeight: 1.5
        },
        mediaThumbnail: {
            width: '100%',
            height: 'auto',
            aspectRatio: '16 / 9',
            borderRadius: 4,
            border: `1px solid ${theme.palette.divider}`,
            display: 'block',
            objectFit: 'cover'
        }
    }
})
